// React binding for the realtime WebSocket connection state. Kept out of
// api/realtime.ts so that module stays framework-free (it's used by non-React
// code paths too). Used to gate the REST fallback polls: while the WS is open,
// it pushes presence/notification/chat updates, so the 60s polls can pause.

import { useSyncExternalStore } from 'react';
import { realtime } from '../realtime';

/**
 * True while the realtime socket is open. Re-renders the caller on every
 * open<->closed transition. Server snapshot is `false` (no socket in SSR).
 */
export function useRealtimeConnected(): boolean {
  return useSyncExternalStore(
    realtime.onConnectedChange,
    realtime.getConnected,
    () => false,
  );
}

/**
 * Poll interval for a WS-backed fallback query: when the socket is open the
 * push keeps the cache live, so polling is off (false); when it's down we fall
 * back to `downMs` (default 60s). Pass the result straight to `refetchInterval`.
 */
export function useFallbackPollInterval(downMs = 60_000): number | false {
  return useRealtimeConnected() ? false : downMs;
}
